<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditTasks
			v-if="task_item"
			:color="'#81CC00'"
			:task="task_item"
			@task-copy="onTaskCopy($event)"
			@task-sub="onTaskSub($event)"
			@task-close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditTasks from "@/views/tasks/edit_task.vue";

export default {
	name: 'EditTaskDialogue',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: true,
			error_msg: '',

			task_id: 0,
			task_item: null
		}
	},
	components: {
		EditTasks
	},
	created() {
		this.task_id = Number(this.$route.params.evid);

		this.getTask(this.task_id);
	},
	methods: {
		async getTask(id) {
			this.loading = true;

			const url = `/api/tasks/${id}?comments=true&worked_on=true`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						this.task_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onTaskCopy(task) {
			window.open(`/desktop/diary/new/1?tasid=${task.id}`, '_self')
		},
		onTaskSub(task) {
			window.open(`/desktop/diary/new/subtask/${task.id}`, '_self')
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>